"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringJoinBuffer = void 0;
/**
 * A place where strings are piled up sequentially to eventually make one big string.
 */
class StringJoinBuffer {
    constructor() {
        this._buff = [];
    }
    Add(...values) {
        this._buff.push(...values);
    }
    AsString() {
        // I experimented with a few approaches to try to make this faster, but none of them made much difference
        // for an 8MB file.  Turns out Array.join is really quite good.
        return this._buff.join("");
    }
}
exports.StringJoinBuffer = StringJoinBuffer;
